module.exports = __webpack_public_path__ + "img/robo2.7bb24648.svg";